import PropTypes from 'prop-types'
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'

import { MetricCard } from '@/components/shared/Metrics'
import { getDealerMetrics } from '@/services/dealer.service'
import { toast } from '@/utils/helpers'

const IntakeKpis = forwardRef(({ dealerId, onViewAdvanced }, ref) => {
  const [loading, setLoading] = useState(false)
  const [kpis, setKpis] = useState(null)

  useImperativeHandle(ref, () => ({
    refresh: () => fetchKpis(),
  }))

  const fetchKpis = async () => {
    const response = await getDealerMetrics(
      dealerId,
      { metric: 'ro_intake_kpis' },
      setLoading,
      (msg) => toast(msg, 'error'),
    )

    if (response) {
      setKpis(response.data)
    }
  }

  useEffect(() => {
    if (dealerId) fetchKpis()
  }, [dealerId])

  return (
    <div>
      <div className="mb-3 flex items-center justify-between">
        <button
          type="button"
          className="flex items-center gap-1.5 py-1.5 text-xs font-bold uppercase tracking-widest text-blue-800 hover:underline"
          onClick={onViewAdvanced}
        >
          <svg
            className="h-4 w-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path d="M3 3v18h18" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 16l4-8 4 4 5-10" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          View Advanced KPIs
        </button>
      </div>

      <div className="text-white-light grid grid-cols-2 gap-4 md:grid-cols-4">
        <MetricCard
          label="Total Active ROs"
          value={kpis?.active}
          loading={loading}
          skeletonWidth="8"
        />
        <MetricCard
          label="Total Intake"
          value={kpis?.intake}
          loading={loading}
          skeletonWidth="8"
        />
        <MetricCard
          label="Intake — No Update 24h"
          value={kpis?.intakeNoUpdate24}
          loading={loading}
          skeletonWidth="8"
        >
          <MetricCard.Tooltip
            content={<span>ROs in intake (Not Started) with no updates in the last 24 hours</span>}
          />
        </MetricCard>
        <MetricCard
          label="OL — Awaiting WPC Review"
          value={kpis?.olWpcReview}
          loading={loading}
          skeletonWidth="8"
        >
          <MetricCard.Tooltip
            content={<span>ROs on the Outstanding List currently in WPC Review</span>}
          />
        </MetricCard>
      </div>
    </div>
  )
})

IntakeKpis.displayName = 'IntakeKpis'

IntakeKpis.propTypes = {
  dealerId: PropTypes.string.isRequired,
  onViewAdvanced: PropTypes.func.isRequired,
}

export default IntakeKpis
